export default {"src":"/_next/static/media/SnowieWateringPlant.efab32af.svg","height":106,"width":164,"blurWidth":0,"blurHeight":0};